import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const FiverrIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('FiverrIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <path d="M15.5 8a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0m-4.187 3.975h-1.97V7.616H7.458v4.359H5.477V7.616H4.354V6.004h1.123v-.49c0-1.278.967-2.15 2.404-2.15h1.462v1.613H8.208c-.46 0-.75.25-.75.657v.37h3.855z" />
  </svg>
);
FiverrIcon.id = 'FiverrIcon';
FiverrIcon.displayName = 'FiverrIcon';
export default FiverrIcon;
